module.exports = __webpack_public_path__ + "static/media/torno4.bcbfa69f.png";